/*
 * @Author: 张天昊
 * @Date: 2024-05-23 11:04:50
 * @LastEditTime: 2025-03-20 17:50:28
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @Description:
 * @FilePath: /Gov-Web/Mobile/src/store/modules/itineraryUniversal.js
 */
import { pick } from 'lodash';
import {
  getItineraryDetailInfo,
  getItineraryDetailInfoByScene,
  guideTeamConfirm,
  agencyAuditConfirm,
  getInsuranceDetailByUserId
} from '@/service';
export default {
  namespaced: true,
  state() {
    return {
      scene: '',
      anchorTarget: {
        type: '',
        id: ''
      },
      detailInfo: {
        loading: false,
        value: null,
        error: null
      },
      touristsInView: [],
      privacyChecked: false,
      userInsuranceDetail: null,
    };
  },
  getters: {
    normalizedTourists(state) {
      return state.detailInfo.value
        ? state.detailInfo.value.itineraryTouristMessage.map((item) =>
            pick(item, [
              'id',
              'name',
              'sexCode',
              'age',
              'ageType',
              'certiNo',
              'certiCodeType',
              'health',
              'originTrip',
              'phone',
              'tourPrice',
              'insuranceStatus'
            ])
          )
        : [];
    }
  },
  mutations: {
    setScene(state, payload) {
      state.scene = payload;
    },
    setAnchorTarget(state, payload) {
      const { type, id } = payload;
      state.anchorTarget.type = type;
      state.anchorTarget.id = id;
    },
    clearAnchorTarget(state) {
      state.anchorTarget.type = '';
      state.anchorTarget.id = '';
    },
    triggerDetailInfoLoading(state) {
      state.detailInfo.loading = true;
    },
    setDetailInfo(state, payload) {
      state.detailInfo.loading = false;
      state.detailInfo.value = payload;
      state.detailInfo.error = null;
    },
    setDetailInfoToutists(state, payload) {
      if (
        state.detailInfo.value &&
        state.detailInfo.value.itineraryTouristMessage
      ) {
        state.detailInfo.value.itineraryTouristMessage = payload;
      }
    },
    setDetailInfoError(state, error) {
      state.detailInfo.loading = false;
      state.detailInfo.value = null;
      state.detailInfo.error = error;
    },
    setTouristsInView(state, payload) {
      state.touristsInView = payload;
    },
    setPrivacyChecked(state, payload) {
      state.privacyChecked = payload;
    },
    setUserInsuranceDetail(state, payload) {
      state.userInsuranceDetail = payload
    }
  },
  actions: {
    /**
     * 请求行程单流程
     * @returns
     */
    async getDetailInfo({ commit, state }, id) {
      if (!id) {
        return;
      }
      commit('triggerDetailInfoLoading');
      let res;
      try {
        // 先根据场景请求权限行程单接口
        res = await getItineraryDetailInfoByScene({ id }, state.scene);
        if (res.ret === 0 && res.data) {
          commit('setDetailInfo', res.data);
        } else {
          getThrough({ id });
        }
      } catch (e) {
        if (e instanceof Error) {
          getThrough({ id });
        } else {
          commit('setDetailInfoError', e);
        }
      }

      // 直接请求无需权限的行程单接口
      async function getThrough() {
        try {
          res = await getItineraryDetailInfo({ id });
          if (res.ret === 0 && res.data) {
            commit('setDetailInfo', res.data);
          } else {
            commit('setDetailInfoError', new Error(res.msg));
          }
        } catch (e) {
          commit('setDetailInfoError', e);
        }
      }
    },
    /**
     * 拒绝/同意带团
     * @returns
     */
    async toggleTourGroup({ dispatch }, { id, state }) {
      try {
        const res = await guideTeamConfirm({ confirm: state, teamId: id });
        if (res.ret === 0) {
          dispatch('getDetailInfo', id);
          return true;
        } else {
          console.error(res.msg);
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 从normalizedTourists里过滤游客ids，以共游客详情页面表格展示
     */
    pickTouristsIntoView({ commit, getters }, ids) {
      const pool = getters.normalizedTourists;
      let selected = [];
      if (!ids) {
        selected = pool.slice();
      } else {
        let enabled = [];
        let disabled = [];
        for (let p of pool) {
          if (ids.includes(p.id)) {
            enabled.push(p);
          } else {
            disabled.push({
              ...p,
              disabled: true
            });
          }
        }
        selected = enabled.concat(disabled);
      }
      commit('setTouristsInView', selected);
    },
    /**
     * 隐私数据查看校验后会返回明文数据的游客信息
     * 替换到detailInfo里面，同时更新touristsInView
     */
    updateTouristsIntoView({ commit, state, dispatch }, datas) {
      commit('setDetailInfoToutists', datas);
      const ids = state.touristsInView.map((item) => item.id);
      dispatch('pickTouristsIntoView', ids);
    },
    /**
     *  旅行社-行程单-通过审核
     * @returns
     */
    async agencyRoleAuditTourGroup({ dispatch }, { id }) {
      try {
        const res = await agencyAuditConfirm({  id: id });
        if (res.ret === 0) {
          dispatch('getDetailInfo', id);
          return true;
        } else {
          console.error(res.msg);
        }
      } catch (e) {
        console.error(e);
      }
    },

    /**
     *  根据游客 ID 获取游客保险详情
     * @param {*} param0 
     */
    async getUserInsuranceDetail({ commit,state },id) {
      try {
        const res = await getInsuranceDetailByUserId({ id },state.scene);
        if (res.ret === 0) {
          commit('setUserInsuranceDetail', res.data);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
